// extracted by mini-css-extract-plugin
module.exports = {"overflow":"ModelRegistry_overflow__ZV0KH","emptyBase":"ModelRegistry_emptyBase__tsc2j","icon":"ModelRegistry_icon__35u6b","description":"ModelRegistry_description__SlORY"};